import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FbOnboardingChecklistDashboardCardService } from './fb-onboarding-checklist-dashboard-card.service';
import { take } from 'rxjs/operators';
import { AppState } from 'app-models';
import { Store } from '@ngrx/store';
import * as FB from './../../form-designer/fb-state/actions/fb.actions';

@Component({
  selector: 'app-fb-onboarding-checklist-dashboard-card',
  templateUrl: './fb-onboarding-checklist-dashboard-card.component.html',
  styleUrls: ['./fb-onboarding-checklist-dashboard-card.component.scss']
})
export class FbOnboardingChecklistDashboardCardComponent implements OnChanges {
  @Input() content: {
    type: string,
    title: string
  };
  employeeId: number;
  finalCheckList = [];
  completedCount = 0;

  private config = {
    'Personal Details': '../employee/profile/education',
    'Education Details': '../employee/profile/education',
    'Experience Details': '../employee/profile/work-experience',
    'Bank Details': '../employee/profile/education'
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fbOnboardingChecklistDashboardCardService: FbOnboardingChecklistDashboardCardService,
    private store: Store<AppState>
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.employeeId = 'loginEmployeeId' in sessionStorage ? Number(sessionStorage.getItem('loginEmployeeId')) : null;
    if (changes.content && this.employeeId) {
      this.fetchDetails();
    }
  }

  fetchDetails() {
    if (this.content) {
      this.fbOnboardingChecklistDashboardCardService.fetchDetails(this.employeeId)
        .pipe(take(1))
        .subscribe((dataList: any[]) => {
          let maxSlno = 0;
          this.finalCheckList = dataList.map(d => {
            maxSlno++;
            return {
              slno: maxSlno,
              sectionName: d.sectionName,
              complete: d.isSectionAvalilable,
              companyId: d.companyId,
              companyName: d.companyName,
              employeeId: d.employeeId,
              beneficiaryId: d.beneficiaryId,
              id: d.id,
              routeUrl: this.config[d.sectionName]
            };
          });
          this.finalCheckList.sort((a, b) => a.slno - b.slno);
          this.completedCount = this.finalCheckList.filter(a => a.complete).length;
        });
    }
  }

  onRedirect(item) {
    sessionStorage.setItem('FbEmployeeId', item.beneficiaryId);
    this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
    setTimeout(() => {
      this.router.navigate([item.routeUrl], {
        queryParams: {
          pageFrom: 'FB',
          fbEmpId: item.id
        },
        relativeTo: this.route
      });
    }, 0);
  }

}
